var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: { id: "rbacMrktPlaceModulesModal", role: "dialog" },
    },
    [
      _c("div", { staticClass: "modal-dialog" }, [
        _c("div", { staticClass: "modal-content first-modal-content" }, [
          _c("div", { staticClass: "modal-header modal-bgcolor" }, [
            _c(
              "button",
              {
                staticClass: "close",
                attrs: { type: "button" },
                on: { click: _vm.cancelPermissions },
              },
              [_vm._v("×")]
            ),
            _c("div", { staticClass: "modal-title" }, [
              _vm._v(_vm._s(_vm.selectedService.name)),
            ]),
            _c("hr"),
          ]),
          _c(
            "div",
            { staticClass: "modal-body module-access" },
            [
              _c("div", { staticClass: "row col-xs-12 m-0 align-right" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn emergo-green-button mr-10 header-buttons",
                    on: { click: _vm.addModule },
                  },
                  [
                    _c("i", { staticClass: "fa fa-plus" }),
                    _vm._v("Add Modules "),
                  ]
                ),
                _c(
                  "button",
                  {
                    staticClass: "btn emergo-green-button ml-25",
                    on: { click: _vm.addOperations },
                  },
                  [
                    _c("i", { staticClass: "fa fa-plus" }),
                    _vm._v("Add Sub Modules "),
                  ]
                ),
              ]),
              _vm._l(_vm.selectedService.modules, function (module, index) {
                return [
                  _c(
                    "div",
                    {
                      key: index,
                      staticClass: "module-text col-xs-12 col-sm-12",
                    },
                    [
                      _c("div", { staticClass: "label_container" }, [
                        _c("span", { staticClass: "checkbox" }, [
                          _c("label", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: module.access,
                                  expression: "module.access",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(module.access)
                                  ? _vm._i(module.access, null) > -1
                                  : module.access,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = module.access,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          module,
                                          "access",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          module,
                                          "access",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(module, "access", $$c)
                                  }
                                },
                              },
                            }),
                            _c("span", { staticClass: "cr" }),
                          ]),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "ml-18 cursor-pointer flex_grow_1",
                            attrs: {
                              "data-toggle": "collapse",
                              "data-target": "#" + index + "_collapse",
                            },
                          },
                          [
                            _c("span", { staticClass: "col-sm-8 col-xs-6" }, [
                              _vm._v(_vm._s(module.name)),
                            ]),
                            _c(
                              "span",
                              {
                                staticClass: "col-sm-3 col-xs-4 xs-pd-0",
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteModule(
                                      "module",
                                      module.name
                                    )
                                  },
                                },
                              },
                              [_vm._m(0, true)]
                            ),
                            _c("span", {
                              staticClass: "collapse_arrow fa fa-angle-down",
                            }),
                          ]
                        ),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "collapse mr-lt-30",
                          attrs: { id: index + "_collapse" },
                        },
                        _vm._l(module.operations, function (operation, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "desc_text mr-rt-30" },
                            [
                              _c(
                                "span",
                                { staticClass: "checkbox inline-checkbox" },
                                [
                                  _c("label", [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: operation.access,
                                          expression: "operation.access",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: { type: "checkbox" },
                                      domProps: {
                                        checked: Array.isArray(operation.access)
                                          ? _vm._i(operation.access, null) > -1
                                          : operation.access,
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$a = operation.access,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  operation,
                                                  "access",
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  operation,
                                                  "access",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(operation, "access", $$c)
                                          }
                                        },
                                      },
                                    }),
                                    _c("span", { staticClass: "cr" }),
                                  ]),
                                ]
                              ),
                              _c("span", { staticClass: "cust_label wd-60" }, [
                                _vm._v(_vm._s(operation.name)),
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass: "inline pd-0",
                                  on: {
                                    click: function ($event) {
                                      return _vm.deleteModule(
                                        "operation",
                                        module.name,
                                        operation.name
                                      )
                                    },
                                  },
                                },
                                [_vm._m(1, true)]
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ]
                  ),
                ]
              }),
              _vm.addModuleFlag
                ? _c("rbac-add-module", {
                    attrs: { serviceModule: _vm.selectedService },
                  })
                : _vm._e(),
              _vm.addOperationsFlag
                ? _c("rbac-add-sub-modules", {
                    attrs: { serviceModule: _vm.selectedService },
                  })
                : _vm._e(),
            ],
            2
          ),
          _c("div", { staticClass: "modal-footer modal-bgcolor" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-sm-12 col-xs-12 col-md-12 footer remove_button_padding",
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-md-3 col-md-offset-6 col-sm-offset-4 col-sm-4 col-xs-6 xs-pd-lt-0",
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-block emergo-white-button",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.cancelPermissions()
                          },
                        },
                      },
                      [_vm._v(" Cancel ")]
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-md-3 col-sm-4 col-xs-6 xs-pd-lt-0 xs-pd-rt-0",
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-block emergo-green-button",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.savePermissions()
                          },
                        },
                      },
                      [_vm._v(" Save ")]
                    ),
                  ]
                ),
              ]
            ),
          ]),
        ]),
      ]),
      _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("a", { staticClass: "text-color-delete-red" }, [
      _c("img", {
        staticClass: "tracker-images",
        attrs: {
          src: "/static/images/icons/delete_icon.svg",
          alt: "delete-icon",
        },
      }),
      _c("span", [_vm._v("Delete")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("a", { staticClass: "text-color-delete-red" }, [
      _c("img", {
        staticClass: "tracker-images",
        attrs: {
          src: "/static/images/icons/delete_icon.svg",
          alt: "delete-icon",
        },
      }),
      _c("span", [_vm._v("Delete")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }